export default __webpack_public_path__ + "static/media/info-verge.b9486c68.png";